function redirectToCheckoutWithDiscount(discountCode) {
	fetch("/cart.js", {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	})
		.then((response) => response.json())
		.then((cart) => {
			const discountUrl = `/checkout?discount=${discountCode}`;
			window.location.href = discountUrl;
		})
		.catch((error) => {
			console.error("Error fetching cart:", error);
		});
}

document.addEventListener("DOMContentLoaded", function () {
	const checkoutButton = document.querySelector(".cart__checkout");

	if (checkoutButton) {
		checkoutButton.addEventListener("click", function (event) {
			event.preventDefault();
			redirectToCheckoutWithDiscount("TRIPLE20");
		});
	}
});
